<template>

  <div v-if="rebuild" class="intro container">
    <img class="intro__artwork" src="../assets/img/intro-claimed.png" alt="">
    <p class="intro__text">Our bricklayers are working hard to add your brick to the Yellow Brick Road...</p>
    <div v-if="loading" class="intro__loader">Please wait</div>
    <button 
      v-if="!loading"
      class="button button--primary intro__cta"
      @click="goToStage"
    >
      Enter the Stage
    </button>
  </div>

  <div v-else-if="search" class="intro container">
    <img class="intro__artwork" src="../assets/img/intro-locating.png" alt="">
    <p class="intro__text">We are working hard to locate your brick on the Yellow&nbsp;Brick&nbsp;Road...</p>
    <div v-if="loading" class="intro__loader">Please wait</div>
    <button 
      v-if="!loading"
      class="button button--primary intro__cta"
      @click="goToStage"
    >
      Enter the Stage
    </button>
  </div>

  <div v-else class="intro container">
    <img class="intro__artwork" src="../assets/img/intro.png" alt="">
    <p class="intro__text">
      Behind the curtains is your unique chance to celebrate 75&nbsp;years of Elton John by adding your own Brick to the Yellow Brick Road.
      <br/>
      <br/>
      Join other fans from around the world and travel the road to discover never-before-seen videos, merchandise and&nbsp;music.
    </p>
    <div v-if="loading" class="intro__loader">Loading</div>
    <button 
      v-if="!loading"
      class="button button--primary intro__cta"
      @click="goToStage"
    >
      Enter the Stage
    </button>
  </div>

</template>

<script>
  export default {
    name: 'Intro',

    data() {
      return {
        loading: true
      }
    },

    props: ['rebuild', 'search'],
    
    mounted() {
      this.$emit('isReady', true);
    },

    methods: {
      updateLoader(){
        this.loading = false;
      },
      goToStage(){
        this.$emit('goToStage', 'stage');
      }
    }
  }
</script>